// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-form-container {
  display: flex;
  gap: 20px;
  padding: 20px;
  max-width: 1280px;
}

.contact-info {
  flex: 1 1;
  background-color: #004d00;
  color: white;
  padding: 2rem;
  border-radius: 10px;
}

.contact-info h2 {
  margin-top: 0;
}

.contact-info p {
  text-align: left;
  color: #c9c9c9;
}

.contact-info ul {
  list-style: none;
  padding: 0;
  margin-top: 2rem;
}

.contact-info ul li {
  margin-bottom: 2rem;
}

.contact-info ul li i {
  margin-right: 10px;
}

.contact-form {
  flex: 2 1;
  background-color: #f9f9f9;
  padding: 20px;
  border-radius: 10px;
}

.contact-form .form-group {
  margin-bottom: 15px;
}

.contact-form label {
  display: block;
  margin-bottom: 5px;
}

.contact-form input,
.contact-form textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
}

.contact-form .button-group {
  display: flex;
  justify-content: flex-end; /* 버튼을 오른쪽으로 정렬 */
}

.contact-form button {
  background-color: #004d00;
  color: white;
  border: none;
  padding: 1rem;
  border-radius: 1rem;
  cursor: pointer;
  font-size: 1rem;
}

.contact-form button:hover {
  background-color: #003300;
}
.email-link {
  color: white;
  text-decoration: none;
}
.email-link:hover {
  text-decoration: underline;
}

  /* 모바일: max-width 768px */

@media (max-width: 768px) {
.contact-form-container{
  display: flex;
  flex-direction: column;
}
.contact-form{
  order:1;
}
.contact-info{
  order:2;
}
.contact-form .form-group{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.form-group{
  width: calc(100% - 10px);
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
}
}

    /* 작은 모바일: max-width 480px */`, "",{"version":3,"sources":["webpack://./src/assets/styles/contactForm.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB,EAAE,iBAAiB;AAC9C;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;;EAEE,yBAAyB;;AAE3B;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,OAAO;AACT;AACA;EACE,OAAO;AACT;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,wBAAwB;EACxB,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;AACA;;IAEI,4BAA4B","sourcesContent":[".contact-form-container {\n  display: flex;\n  gap: 20px;\n  padding: 20px;\n  max-width: 1280px;\n}\n\n.contact-info {\n  flex: 1;\n  background-color: #004d00;\n  color: white;\n  padding: 2rem;\n  border-radius: 10px;\n}\n\n.contact-info h2 {\n  margin-top: 0;\n}\n\n.contact-info p {\n  text-align: left;\n  color: #c9c9c9;\n}\n\n.contact-info ul {\n  list-style: none;\n  padding: 0;\n  margin-top: 2rem;\n}\n\n.contact-info ul li {\n  margin-bottom: 2rem;\n}\n\n.contact-info ul li i {\n  margin-right: 10px;\n}\n\n.contact-form {\n  flex: 2;\n  background-color: #f9f9f9;\n  padding: 20px;\n  border-radius: 10px;\n}\n\n.contact-form .form-group {\n  margin-bottom: 15px;\n}\n\n.contact-form label {\n  display: block;\n  margin-bottom: 5px;\n}\n\n.contact-form input,\n.contact-form textarea {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n}\n\n.contact-form .button-group {\n  display: flex;\n  justify-content: flex-end; /* 버튼을 오른쪽으로 정렬 */\n}\n\n.contact-form button {\n  background-color: #004d00;\n  color: white;\n  border: none;\n  padding: 1rem;\n  border-radius: 1rem;\n  cursor: pointer;\n  font-size: 1rem;\n}\n\n.contact-form button:hover {\n  background-color: #003300;\n}\n.email-link {\n  color: white;\n  text-decoration: none;\n}\n.email-link:hover {\n  text-decoration: underline;\n}\n\n  /* 모바일: max-width 768px */\n\n@media (max-width: 768px) {\n.contact-form-container{\n  display: flex;\n  flex-direction: column;\n}\n.contact-form{\n  order:1;\n}\n.contact-info{\n  order:2;\n}\n.contact-form .form-group{\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n.form-group{\n  width: calc(100% - 10px);\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: row;\n}\n}\n\n    /* 작은 모바일: max-width 480px */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
